import Vue from 'vue';
import store from '@/store';
import Spinner from '@/components/common/spinner/spinner.vue';
import Logger from '@/logger';
import Crud, { CARTS } from '@/api/crud';
import Modal from '@/components/common/dialog/dialog.vue';
import CartsRepository from '@/repositories/carts-repository.ts';
import UsersRepository from '@/repositories/users-repository.ts';
import { textChangeRangeIsUnchanged } from 'typescript';
import { required, email } from 'vuelidate/lib/validators';
import { CART_SHARED, CART_UNSHARED } from '@/store/mutation-types.js';

import l10n from '@/transformers/l10n';

const logger = new Logger('CartSharing');

export default {
    store,
    components: { Modal, Spinner },
    data() {
        return {
            opts: {
                confirmText: l10n('cart.sharing.button.save'),
                cancelText: l10n('cart.sharing.button.close'),
                showConfirm: false,
                canCloseChecker: this.canClose,
                closeOnBackdrop: true
            },
            email: "",
            participants: [],
            loading: false
        };
    },
    props: ['cartId', 'showId'],
    computed: {
        repository() {
            return new CartsRepository(this.showId, this.cartId);
        },
        usersRepository() {
            return new UsersRepository();
        }
    },
    validations: {
        email: {
            required, email
        }
    },
    methods: {
        invitePlaceholder() {
            return l10n('cart.sharing.placeholder.shareemail');
        },
        setFocusOnModal() {
            this.$refs.cart_sharing_modal.focus();
        },
        async loadSharing() {
            this.loading = true;

            try {
                this.participants = await this.repository.sharing();
            } catch (err) {
                logger.error('Error loading cart sharing information', err);
            } finally {
                this.loading = false;
            }
        },
        share() {
            if (this.$v.$invalid) {
                return;
            }

            for (var i = 0; i < this.participants.length; i++) {
                if (this.participants[i].email === this.email) {
                    return;
                }
            }

            var participant = {
                email: this.email,
                add: true
            }
            this.participants.push(participant);
            this.checkParticipant(participant);
            this.email = "";
            this.$refs.input.focus();
            this.invalidateBtnsState();
        },
        unshare(participant) {
            if (participant.add) {
                this.participants.splice(this.participants.indexOf(participant), 1);
            } else {
                Vue.set(participant, 'remove', true);
            }
            this.invalidateBtnsState();
        },
        invalidateBtnsState() {
            for (var i = 0; i < this.participants.length; i++) {
                if (this.participants[i].add ||
                    this.participants[i].remove) {
                    this.opts.showConfirm = true;
                    this.opts.closeOnBackdrop = false;
                    this.opts.cancelText = l10n('cart.sharing.button.cancel');
                    return;
                }
            }
            this.opts.showConfirm = false;
            this.opts.cancelText = l10n('cart.sharing.button.close');
        },
        canClose() {
            if (this.opts.showConfirm) {
                let toRemove = []
                for (var i = 0; i < this.participants.length; i++) {
                    if (this.participants[i].add) {
                        toRemove.push(this.participants[i]);
                    }

                    if (this.participants[i].remove) {
                        this.participants[i].remove = false;
                    }
                }

                for (var i = 0; i < toRemove.length; i++) {
                    this.unshare(toRemove[i]);
                }
                this.invalidateBtnsState();
                return false;
            }
            return !this.opts.showConfirm;
        },
        async checkParticipant(participant) {
            try {
                var users = await this.usersRepository.users(participant.email);
                if (users.length === 0) {
                    // Vue.set(participant, 'name', 'Not found');
                    // Vue.set(participant, 'notFound', true);
                    return;
                }

                Vue.set(participant, 'name', `${users[0].firstName} ${users[0].lastName}`);
                Vue.set(participant, 'userName', users[0].userName);
            } catch (err) {
                logger.error('Error loading participant', err);
            } finally {
                this.invalidateBtnsState();
            }
        },
        async save() {
            let toShare = [];
            let toUnshare = [];
            for (var i = 0; i < this.participants.length; i++) {
                if (this.participants[i].add) {
                    toShare.push(this.participants[i].userName || this.participants[i].email);
                }

                if (this.participants[i].remove) {
                    toUnshare.push(this.participants[i].userName);
                }
            }

            if (toShare.length > 0) {
                await this.repository.share(toShare);
                this.$store.commit(CART_SHARED, { id: this.cartId, participants: toShare });
            }
            if (toUnshare.length > 0) {
                await this.repository.unshare(toUnshare);
                this.$store.commit(CART_UNSHARED, { id: this.cartId, participants: toUnshare });
            }

            this.$emit('confirm')
        }
    },
    created() {
        this.loadSharing();
    },
    mounted() {
        this.$refs.input.focus();
    }
}